<template>
    <div class="page-content">
        <div class="page-top">
            <div class="city-name">{{name}}</div>
            <div class="select-content">
                <div class="color-gray">选择地区：</div>
                <el-select v-model="name" filterable>
                    <el-option v-for="(item,index) in cityList" :key="index" :label="item.name" :value="item.name"></el-option>
                </el-select>
            </div>
        </div>
        <div class="page-tabs">
            <div class="tabs-item"
                 :class="{active: tabIndex===item.id}"
                 v-for="(item,index) in tabList"
                 @click="tabIndex=item.id"
                 :key="index">{{item.name}}</div>
        </div>
        <div class="card-content">
            <component showAddress :is="comName" v-for="item in list" :key="item.id" :item="item"></component>
        </div>
        <div v-if="!finish" class="load-content">上拉加载更多 <i class="el-icon-loading"></i></div>
    </div>
</template>

<script>
    import HouseCard from "@/components/HouseCard";
    import StoryCard from "@/components/StoryCard";
    import {mapState} from 'vuex'
    export default {
        name: "hotCity",
        components:{HouseCard, StoryCard},
        data(){
            return {
                name: '',
                tabList: [
                    {id: 1, name: '房源'},
                    {id: 2, name: '景点'},
                    {id: 3, name: '温泉'},
                    {id: 4, name: '美食'},
                    {id: 5, name: '路线'},
                ],
                tabIndex: 1,
                searchForm:{
                    page: 1,
                    nums: 12,
                    area_id: '',
                    address: ''
                },
                list: [],
                finish: false
            }
        },
        created(){
            this.name = this.$route.query.name;
            this.$eventBus.$on('onBottom', this.handlerBottom)
        },
        beforeDestroy(){
            this.$eventBus.$off('onBottom', this.handlerBottom)
        },
        computed:{
            ...mapState(['cityList']),
            comName(){
                if(this.tabIndex === 1){
                    return 'HouseCard'
                }
                return  'StoryCard'
            }
        },
        watch:{
            name(){
                this.searchForm.address = this.name;
                let obj = this.cityList.find(it=>it.name === this.name)
                if(obj){
                    this.searchForm.area_id = obj.id;
                }
                this.finish = false;
                this.searchForm.page = 1;
                this.getData();
            },
            tabIndex(){
                this.finish = false;
                this.searchForm.page = 1;
                this.getData();
            }
        },
        methods:{
            handlerBottom(){
                if(this.finish) return;
                this.searchForm.page++;
                this.getData();
            },
            getData(){
                if(this.tabIndex === 1){
                    this.getLandlord();
                }else if(this.tabIndex === 2){
                    this.getScenery()
                }else if(this.tabIndex === 3){
                    this.getHotSpring()
                }else if(this.tabIndex === 4){
                    this.getCate()
                }else if(this.tabIndex === 5){
                    this.getTouristSearch()
                }
            },
            async getLandlord(){
                let [e, data] = await this.$api.getLandlordApi(this.searchForm)
                if(e) return;
                if(data.code === 200){
                    if(this.searchForm.page === 1){
                        this.list = data.result.house;
                    }else {
                        this.list =[...this.list, ...data.result.house];
                    }
                    this.finish = data.result.house.length < this.searchForm.nums;
                }
            },
            async getScenery(){
                let [e, data] = await this.$api.getSceneryApi(this.searchForm)
                if(e) return;
                if(data.code === 200){
                    if(this.searchForm.page === 1){
                        this.list = data.result;
                    }else {
                        this.list =[...this.list, ...data.result];
                    }
                    this.finish = data.result.length < this.searchForm.nums;
                }
            },
            async getHotSpring(){
                let [e, data] = await this.$api.getHotSpringApi(this.searchForm)
                if(e) return;
                if(data.code === 200){
                    if(this.searchForm.page === 1){
                        this.list = data.result;
                    }else {
                        this.list =[...this.list, ...data.result];
                    }
                    this.finish = data.result.length < this.searchForm.nums;
                }
            },
            async getCate(){
                let [e, data] = await this.$api.getCateApi(this.searchForm)
                if(e) return;
                if(data.code === 200){
                    if(this.searchForm.page === 1){
                        this.list = data.result;
                    }else {
                        this.list =[...this.list, ...data.result];
                    }
                    this.finish = data.result.length < this.searchForm.nums;
                }
            },
            async getTouristSearch(){
                let [e, data] = await this.$api.getTouristSearchApi(this.searchForm)
                if(e) return;
                if(data.code === 200){
                    if(this.searchForm.page === 1){
                        this.list = data.result;
                    }else {
                        this.list =[...this.list, ...data.result];
                    }
                    this.finish = data.result.length < this.searchForm.nums;
                }
            },
        }
    }
</script>

<style scoped lang="less">
    .page-top{
        width: 100%;
        height: 230px;
        background: url("./../assets/img/hotb.jpg") 100% 100% no-repeat;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
        .city-name{
            font-size: 40px;
            line-height: 1.5;
            color: #ffffff;
            font-weight: bold;
        }
        .select-content{
            width: 460px;
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 6px;
            background-color: #ffffff;
            margin-top: 10px;
        }
    }
    .page-tabs{
        width: 100%;
        height: 68px;
        border-bottom: 1px solid #e2e2e2;
        background-color: #ffffff;
        position: sticky;
        top: 80px;
        left: 0;
        z-index: 9;
        display: flex;
        justify-content: center;
        align-items: center;
        .tabs-item{
            height: 68px;
            line-height: 68px;
            width: 88px;
            text-align: center;
            cursor: pointer;
        }
        .active{
            color: #e44646;
        }
    }
</style>
